<div class="table-container" [class.height]="initialLoading || !!error || !hasTransactions">
  <!-- Loading spinner for initial load -->
  @if (initialLoading) {
    <div class="loading-container">
      <app-loading-spinner size="large" label="Loading transactions..."></app-loading-spinner>
    </div>
  }

  <!-- Error message -->
  @if (error && !initialLoading) {
    <div class="error-container">
      <p class="error-message">{{ error }}</p>
      <button class="retry-button" (click)="onRetry()">
        {{ mergedConfig.retryText }}
      </button>
    </div>
  }

  <!-- Transactions table -->
  @if (!initialLoading && !error) {
    <table [class.has-risk-column]="hasRiskColumn">
      <thead>
        <tr>
          <th class="direction-header" aria-label="Direction"></th>
          @for (column of mergedConfig.columns; track column) {
            <th>{{ column }}</th>
          }
        </tr>
      </thead>
      @if (hasTransactions) {
        <tbody>
          @for (transaction of transactions; track transaction.id) {
            <tr
              (click)="onTransactionClick(transaction)"
              [class.selected]="selectedTransaction?.id === transaction.id"
              class="transaction-row"
              >
              <td class="direction-cell">
                @if (getDirectionIcon(transaction.transactionDirection)) {
                  <span
                    class="direction-indicator direction-{{ transaction.transactionDirection?.toLowerCase() }}"
                    [matTooltip]="transaction.transactionDirection!"
                    matTooltipPosition="above"
                    >
                    <mat-icon>{{ getDirectionIcon(transaction.transactionDirection) }}</mat-icon>
                  </span>
                }
              </td>
              <td>
                <div class="type-cell">
                  {{ transaction.direction }}
                  @if (transaction.isPaymentApi) {
                    <span class="api-label">API</span>
                  }
                  @if (transaction.hangfireFailure) {
                    <span
                [matTooltip]="
                  'Hangfire Error' + (transaction.hangfireFailureReason ? '\n' + transaction.hangfireFailureReason : '')
                "
                      matTooltipPosition="above"
                      class="hangfire-error"
                      >
                      <mat-icon>error_outline</mat-icon>
                    </span>
                  }
                </div>
              </td>
              <td>
                <span class="olv-address" [matTooltip]="transaction.sendingWallet" matTooltipPosition="above">
                  {{ shortenAddress(transaction.sendingWallet) }}
                </span>
              </td>
              <td>
                <span class="olv-address" [matTooltip]="transaction.receivingWallet" matTooltipPosition="above">
                  {{ shortenAddress(transaction.receivingWallet) }}
                </span>
              </td>
              <td>{{ transaction.cryptocurrency }}</td>
              <td>
                <div class="amount-cell">
                  {{ formatAmount(transaction) }}
                  @if (isSettlementApp && transaction.requiresExchangeRateOverride) {
                    <span
                      class="pending-rate-indicator"
                      role="img"
                      [attr.aria-label]="pendingRateTooltip"
                      [matTooltip]="pendingRateTooltip"
                      matTooltipPosition="above"
                      >
                      <mat-icon aria-hidden="true">sync_problem</mat-icon>
                    </span>
                  } @else if (isSettlementApp && transaction.isExchangeRateOverridden) {
                    <span
                      class="manual-rate-indicator"
                      role="img"
                      [attr.aria-label]="manualRateTooltip"
                      [matTooltip]="manualRateTooltip"
                      matTooltipPosition="above"
                      >
                      <mat-icon aria-hidden="true">sync_problem</mat-icon>
                    </span>
                  }
                </div>
              </td>
              <td>
                {{
                getIsExchange(transaction.direction)
                ? formatDateStandard(transaction.date).slice(0, 10)
                : formatDateStandard(transaction.date)
                }}
              </td>
              @if (isSettlementApp) {
                <td>
                  <div class="risk-container">
                    <app-state-badge [value]="transaction.riskLevel" [type]="'risk'"></app-state-badge>
                  </div>
                </td>
              }
              <td>
                <span class="status-text">
                  {{ transaction.status }}
                </span>
              </td>
              @if (showActionColumn) {
                <td class="empty-column">
                  @if (transaction.canSpeedup) {
                    <button
                      mat-icon-button
                      class="action-btn"
                      *appHasPermission="{ resource: getTransactionResource(transaction), scope: Scopes.Speedup }"
                      (click)="$event.stopPropagation(); openOtp('speedup', transaction)"
                      matTooltip="Speed Up"
                      >
                      <mat-icon>keyboard_double_arrow_right</mat-icon>
                    </button>
                  }
                  @if (transaction.canCancel) {
                    <button
                      mat-icon-button
                      class="action-btn"
                      *appHasPermission="{ resource: getTransactionResource(transaction), scope: Scopes.Cancel }"
                      (click)="$event.stopPropagation(); openOtp('cancel', transaction)"
                      matTooltip="Cancel"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      } @else {
        @if (mergedConfig.showEmptyState) {
          <tr>
            <td [attr.colspan]="(mergedConfig.columns?.length || 8) + 1">
              <app-empty-state [filtersApplied]="filtersApplied" [searchText]="searchText"></app-empty-state>
            </td>
          </tr>
        }
      }
    </table>
  }

  <app-show-more
    [isShowMore]="hasTransactions && hasMoreTransactions && (mergedConfig.showLoadMore || false) && !initialLoading"
    [isLoading]="isLoading"
    [text]="{
      loadingText: mergedConfig.loadingText || 'Loading...',
      showMoreText: mergedConfig.loadMoreText || 'Show more',
    }"
    (loadMore)="onLoadMore()"
    >
  </app-show-more>

</div>
